module.exports = __webpack_public_path__ + "static/media/ob_t.0713d99c.svg";